import { createAction } from "@reduxjs/toolkit";
export var setRoom = createAction("room/setRoom");
export var joinRoom = createAction("room/joinRoom");
export var leaveRoom = createAction("room/leaveRoom");
export var exitRoom = createAction("room/exitRoom");
export var updateRoomName = createAction("room/updateRoomName");
export var updateStage = createAction("room/updateStage");
